var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_show)?_c('div',{class:['cover_icon','cover_icon_'+_vm.size],style:(_vm.style)},[_vm._v(_vm._s(this.cover_info.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }